// extracted by mini-css-extract-plugin
export default {"topSloganContainer":"HeaderSideSlogans_topSloganContainer__gZVAM","bottomSloganContainer":"HeaderSideSlogans_bottomSloganContainer__dHe9p"};